import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled, { css, keyframes } from 'styled-components';

import { getMedia, getMediaMin, percent } from '../../../helpers/layout';

export const Content = styled.div`
    display: block;
    max-width: ${percent(1920, 523)}vw;
    align-self: flex-end;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        max-width: ${percent(1366, 382)}vw;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        max-width: ${percent(768, 433)}vw;
    }

    @media only screen and ${getMedia('phone')} {
        max-width: none;
    }

    @media only screen and (max-aspect-ratio: 4/3) and ${getMediaMin('tablet')} {
        align-self: center;
        padding-top: 60vh;
        max-width: 60%;
    }
`;

export const Text = styled.p`
    ${FONTS.S};
    color: ${COLORS.TextPrimary};
    max-width: 86%;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        max-width: 99%;
    }

    @media only screen and ${getMedia('tablet')} {
        max-width: none;
    }

    & + & {
        margin-top: 8px;

        @media only screen and ${getMedia('phone')} {
            margin-top: 12px;
        }
    }
`;

export const Title = styled.h2`
    ${FONTS.H1};
    color: #333;

    @media only screen and ${getMedia('desktop', 'phone')} {
        ${FONTS.H2};
    }

    @media only screen and ${getMedia('phone')} {
        ${FONTS.H3};
    }

    & + ${Text} {
        margin-top: 20px;

        @media only screen and ${getMedia('desktop', 'tablet')} {
            margin-top: 15px;
        }

        @media only screen and ${getMedia('phone')} {
            margin-top: 18px;
        }
    }
`;

export const Composition = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-46%);
    right: -3.7vw;
    display: inline-block;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        transform: translateY(-47.2%);
        right: -4.3vw;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        transform: none;
        top: auto;
        bottom: 7.9vw;
        right: -6.1vw;
    }

    @media only screen and ${getMedia('phone')} {
        transform: none;
        top: auto;
        bottom: 27.9vw;
        right: -13.7vw;
    }

    @media only screen and (max-aspect-ratio: 4/3) and ${getMediaMin('tablet')} {
        top: 40%;
        right: -8.3vw;
    }
`;

export const PhoneWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    perspective: 124vw;
    perspective-origin: 107% -65%;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        perspective: 117vw;
    }

    @media only screen and ${getMedia('tablet')} {
        display: none;
    }
`;

export const PhoneContainer = styled.div`
    position: absolute;
    bottom: ${percent(1159, 161)}%;
    left: ${percent(1538, 872)}%;
    background-color: #000;
    width: ${percent(1538, 370)}%;
    height: ${percent(1159, 157)}%;
    transform-origin: center;
    transform: rotateY(-29deg) rotateX(94deg) rotateY(-2deg);
`;

export const TabletWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    perspective: 117vw;
    perspective-origin: 74% -53%;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        perspective: 113vw;
    }

    @media only screen and ${getMedia('tablet')} {
        display: none;
    }
`;

export const TabletContainer = styled.div`
    position: absolute;
    bottom: ${percent(1159, 38)}%;
    left: ${percent(1538, 247)}%;
    background-color: #000;
    width: ${percent(1538, 573)}%;
    height: ${percent(1159, 308)}%;
    transform-origin: center;
    transform: rotateY(-30deg) rotateX(94deg) rotateY(-2deg);
    object-fit: cover;
`;

export const DesktopWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    perspective: 198vw;
    perspective-origin: 24% -62%;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        perspective: 186vw;
    }

    @media only screen and ${getMedia('tablet')} {
        display: none;
    }
`;

export const DesktopContainer = styled.div`
    position: absolute;
    bottom: ${percent(1159, 590)}%;
    left: ${percent(1538, 364)}%;
    background-color: #000;
    width: ${percent(1538, 890)}%;
    height: ${percent(1159, 457)}%;
    transform-origin: center;
    transform: rotateY(-53deg) rotateX(7deg);
`;

export const Video = styled.video`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const Poster = styled.picture`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.3s ease-out;

    ${({ isPlaying }) => {
        if (isPlaying) {
            return css`opacity: 0;`;
        }
    }}
`;

export const PosterSource = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const Mask = styled.picture`
    display: block;

    @media only screen and ${getMedia('tablet')} {
        display: none;
    }
`;

export const MaskFull = styled(Mask)`
    display: none;

    @media only screen and ${getMedia('tablet')} {
        display: block;
    }
`;

export const MaskSource = styled.img`
    position: relative;
    display: block;
    width: ${percent(1920, 1235)}vw;
    z-index: 10;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        width: ${percent(1366, 847)}vw;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        width: ${percent(768, 770)}vw;
    }

    @media only screen and ${getMedia('phone')} {
        width: ${percent(320, 364)}vw;
    }
`;

export const Label = styled.span`
    position: absolute;
    right: 73px;
    ${FONTS.XXS};
    color: #828282;
    max-width: 100%;
    bottom: 27px;
    z-index: 11;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        right: 45px;
        bottom: 21px;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        right: 60px;
        left: 60px;
        bottom: ${percent(768, 21)}vw;
    }

    @media only screen and ${getMedia('phone')} {
        right: 20px;
        left: 20px;
        bottom: ${percent(320, 19)}vw;
        ${FONTS.XXS};
    }
`;

export const Section = styled.section`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    background: linear-gradient(59.34deg, #D6D6D6 0%, #E7E7E7 0.01%, #F7F7F7 41.08%, #EBEBEB 71.84%, #E8E8E8 107.74%);
    padding: 127px 117px 129px;
    will-change: opacity;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        padding: 70px 79px 48px;
    }

    @media only screen and ${getMedia('tablet', 'phone')} {
        display: block;
        position: relative;
        padding: 133px 62px ${percent(768, 663)}vw;
        height: auto;
    }

    @media only screen and ${getMedia('phone')} {
        display: block;
        position: relative;
        height: auto;
        padding: 89px 20px ${percent(320, 371)}vw;
    }

    @media only screen and ${getMediaMin('tablet')} {
        ${({ isActive }) => {
            if (isActive) {
                return css`
                    transition: opacity 0.4s ease-out;
                    opacity: 1;
                    z-index: 10;

                    ${Title},
                    ${Text} {
                        opacity: 1;
                        transform: translateY(0);
                    }

                    ${Title} {
                        transition: opacity 0.3s ease-out 0.4s, transform 0.3s ease-out 0.4s;
                    }

                    ${Text} {
                        transition: opacity 0.3s ease-out 0.7s, transform 0.3s ease-out 0.7s;
                    }
                `;
            } else {
                return css`
                    opacity: 0;
                    transition: opacity 0.4s ease-out 0.4s;

                    ${Title},
                    ${Text} {
                        opacity: 0;
                        transform: translateY(45px);
                        transition: opacity 0.3s ease-out 0.4s, transform 0.3s ease-out 0.4s;
                    }
                `;
            }
        }}
    }
`;

const rotate = keyframes`
    from {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    to {
        transform: translate(-50%, -50%) rotate(360deg);
    }
`;

export const Preloader = styled.img`
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${percent(2588, 210)}%;
    animation: ${rotate} 1s linear infinite;
    z-index: 1;
`;
